<template>
    <pm-custom-dialog v-if="visible" v-model="visible">
        <div style="margin-top: 26px; margin-bottom: 16px; text-align: center;">
            <h2 style="line-height: 1.2; font-weight: 600; text-shadow: 0.5px 0.5px 0 #000;">Demo prices</h2>
        </div>
        <p style="line-height: 1.3; font-size: 15px; margin-bottom: 8px; padding: 0 30px;">
            <span v-html="$t('welcome.demo_prices_desc')"></span>
        </p>
        <br/>
        <div @click="close" style="background: url(/images/onboarding/pricelist.jpg) center center / contain no-repeat rgb(255, 255, 255); margin: 0px 0px 20px 0; width: 100%; height: 400px;"></div>
    </pm-custom-dialog>
</template>
<script>
import PmCustomDialog from "./base-dialog.vue";
export default {
    components: {
        PmCustomDialog
    },
    data: () => ({
        visible: false,
    }),
    created() {

    },
    methods: {
        show() {
            this.visible = true;
        },
        close() {
            this.visible = false;
            this.$emit('close');
        },
    }
}
</script>
